// src/pages/DashboardNavigation/components/PageIndicator.jsx

import React from "react";
import { FaChevronDown, FaChevronUp, FaListUl } from "react-icons/fa";

export default function PageIndicator({
  currentPage,
  currentIndex,
  total,
  drawerOpen,
  onToggle,
}) {
  const Icon = drawerOpen ? FaChevronUp : FaChevronDown;
  const knownPage = currentIndex >= 0;

  return (
    <button
      type="button"
      onClick={onToggle}
      className="flex min-h-[64px] min-w-[92px] flex-col items-center justify-center rounded-2xl bg-slate-950 px-2 py-2 text-center text-white shadow-sm ring-1 ring-slate-900 transition hover:-translate-y-0.5 hover:bg-slate-900 active:scale-[0.98] dark:bg-white dark:text-slate-950 dark:ring-white"
      aria-expanded={drawerOpen}
      aria-label="Afficher toutes les pages du tableau de bord"
    >
      <span className="flex items-center gap-1.5 text-[9px] font-bold uppercase tracking-[0.16em] text-slate-300 dark:text-slate-500">
        <FaListUl className="text-[10px]" />
        Pages
      </span>

      <span className="mt-1 text-sm font-bold leading-none">
        {knownPage ? `${currentIndex + 1}/${total || 1}` : "—"}
      </span>

      <span className="mt-1 flex max-w-[110px] items-center gap-1 truncate text-[10px] font-semibold text-slate-300 dark:text-slate-500">
        <span className="truncate">{currentPage?.label || "Menu"}</span>
        <Icon className="shrink-0 text-[9px]" />
      </span>
    </button>
  );
}